import React from "react";
import PropTypes from "prop-types";
import {
  SFGridContainer,
  SFGridItem,
  SFTypography,
  getStyled,
} from "@sf-core";
import SFCard, { SFCardBody } from "./index";
import SFBadgeIcons from "../badgeIcon";
const { styled } = getStyled();

const StyledAnalysisWrapper = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const StyledDescriptionLabel = styled("div")(({ theme }) => ({
  ...theme.typography.body1,
}));

const StyledHelperLabel = styled("div")(({ theme }) => ({
  ...theme.typography.body2,
}));

const SFGeneralInfoCard = ({
  name,
  description,
  badges,
  actionButtons,
  helperText,
  showHierarchy
}) => {
  return (
    <SFCard>
      <SFCardBody>
        <SFGridContainer spacing={1}>
          <SFGridItem xs={12}>
            <SFTypography variant="h2">{name}</SFTypography>
            {helperText && (
              <StyledHelperLabel
                dangerouslySetInnerHTML={{ __html: helperText }}
              />
            )}
          </SFGridItem>

          {description && (
            <SFGridItem xs={12}>
              <StyledDescriptionLabel
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </SFGridItem>
          )}
          {badges && (
            <SFGridItem xs={12}>
              <StyledAnalysisWrapper>
                <SFBadgeIcons badges={badges} showHierarchy={showHierarchy}/>
              </StyledAnalysisWrapper>
            </SFGridItem>
          )}
        </SFGridContainer>

        {/* I Don't see this been used anywhere */}
        {/* {actionButtons &&
          actionButtons.map((btn, index) => (
            <SFGridItem xs={"auto"} key={index}>
              {btn}
            </SFGridItem>
          ))} */}
      </SFCardBody>
    </SFCard>
  );
};

SFGeneralInfoCard.propTypes = {
  name: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.number,
      ]),
      icon: PropTypes.node,
    })
  ),
  actionButtons: PropTypes.arrayOf(PropTypes.element),
  helperText: PropTypes.string,
  showHierarchy: PropTypes.bool
};

export default SFGeneralInfoCard;
